import { containsDevanagari, DEVANAGARI_FONT } from './scripts.js';
/** The row look for row `i` (or null). */
export function rowStyleAt(style, i) {
    return style.lineStyles?.[i] ?? null;
}
export function resolveWordLook(style, word, row) {
    const ws = word.wordStyle ?? null;
    const emph = word.emphasized ? style.emphasis : null;
    const baseWeight = row?.fontWeight ?? style.fontWeight;
    const bold = Boolean((emph && emph.bold) || word.bold);
    let weight = bold ? Math.max(baseWeight, 700) : baseWeight;
    if (emph?.fontWeight)
        weight = emph.fontWeight;
    if (ws?.fontWeight)
        weight = ws.fontWeight;
    // A Devanagari word always uses the Devanagari font (no tofu), which wins.
    const family = containsDevanagari(word.text)
        ? DEVANAGARI_FONT
        : ws?.fontFamily ?? emph?.fontFamily ?? row?.fontFamily ?? style.fontFamily;
    const italic = Boolean(ws?.italic ?? emph?.italic ?? row?.italic ?? false);
    const fill = ws?.fill ?? emph?.fill ?? 'solid';
    const gradient = ws?.gradient ?? emph?.gradient ?? undefined;
    const strokeRaw = ws?.stroke ?? emph?.stroke ?? style.stroke;
    const stroke = strokeRaw && strokeRaw.widthPx > 0 ? strokeRaw : undefined;
    const glow = ws?.glow ?? emph?.glow ?? undefined;
    const motionRaw = ws?.motion ?? emph?.motion ?? undefined;
    // Keep an explicit still motion so the renderer suppresses inherited reveal.
    const motion = motionRaw?.in ? motionRaw : undefined;
    return {
        family,
        weight,
        italic,
        fill,
        gradient: gradient ?? undefined,
        stroke,
        glow: glow ?? undefined,
        highlightColor: ws?.highlightColor ?? undefined,
        motion,
        rowColor: row?.color ?? undefined,
        rowSize: row?.size && row.size > 0 ? row.size : 1,
    };
}
//# sourceMappingURL=word-look.js.map